import { FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";
import { InformationPopup } from "../../SharedComponents/InformationPopup";
import { Table } from "@sainsburys-tech/luna-table";
import { DefaultTableCellRender } from "../../SharedComponents/EditableTable";

/****************Important Notes**************
  outerdimensions will be relaced by breakpack
  innerdimensions by casedimensions
*****************Important Notes*************/

const ProductMeasurements: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);

  const columnDefinition: IColumn[] = [
    {
      name: "Item Number",
      accessor: "SainId",
    },
    {
      name: "Display Item Number",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SkuNumber ? rowData?.SkuNumber : rowData?.CatNumber,
        };
      },
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: "UOM",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_SKU ||
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_PACK
              ? `CS${rowData?.PackSize}`
              : rowData?.Alias === UI_CONSTANTS.ARGOS
              ? (rowData?.PackSize == 1) ? `EA` : `CS${rowData?.PackSize}`
              : rowData?.PackSize,
        };
      },
    },
    {
      name: "Packaging Type",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.ARGOS
              ? `${rowData?.PackagingType ? rowData?.PackagingType : ""}`
              : "",
        };
      },
    },
    {
      name: `${UI_CONSTANTS.CASEWIIGHTSANDDIMS}`,
      accessor: (rowData: any) => {
        return {
          value: rowData,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: any; row: any }) => {
        return value ? (
          <div>
            <InformationPopup
              linkText={
                value?.length > 0 ? UI_CONSTANTS.CASEWIIGHTSANDDIMS : null
              }
              modalHeading={`${UI_CONSTANTS.CASEWIIGHTSANDDIMS} - ${row?.SainId}`}
              dataPage={UI_CONSTANTS.CASEWIIGHTSANDDIMS}
              initialValue={row?.SainId}
            >
              <Table
                data={[value]}
                columns={[
                  {
                    name: "Case TI",
                    accessor: (rowData: any) => ({
                      value: rowData?.DimensionData?.InnerDimensions?.Ti,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Case HI ",
                    accessor: (rowData: any) => ({
                      value: rowData?.DimensionData?.InnerDimensions?.Hi,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Case Length",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.InnerDimensions?.Length
                          ? `${rowData?.DimensionData?.InnerDimensions?.Length} ${rowData?.DimensionData?.InnerDimensions?.LengthUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Case Width",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.InnerDimensions?.Width
                          ? `${rowData?.DimensionData?.InnerDimensions?.Width} ${rowData?.DimensionData?.InnerDimensions?.WidthUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Case Height",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.InnerDimensions?.Height
                          ? `${rowData?.DimensionData?.InnerDimensions?.Height} ${rowData?.DimensionData?.InnerDimensions?.HeightUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Case Weight",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.InnerDimensions?.Weight
                          ? `${rowData?.DimensionData?.InnerDimensions?.Weight} ${rowData?.DimensionData?.InnerDimensions?.WeightUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : (
          "--"
        );
      },
    },
    {
      name: "Break Pack Indicator",
      type: "tick",
      customClass: "customColBoolean",
      accessor: (rowData: any) => {
        return {
          value: rowData?.DimensionData?.BreakPackIndicator,
          row: rowData,
        };
      },
    },
    {
      name: `${UI_CONSTANTS.BREAKWIIGHTSANDDIMS}`,
      accessor: (rowData: any) => {
        return {
          value: rowData,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: any; row: any }) => {
        return value ? (
          <div>
            <InformationPopup
              linkText={
                value?.length > 0 ? UI_CONSTANTS.BREAKWIIGHTSANDDIMS : null
              }
              modalHeading={`${UI_CONSTANTS.BREAKWIIGHTSANDDIMS} - ${row?.SainId}`}
              dataPage={UI_CONSTANTS.BREAKWIIGHTSANDDIMS}
              initialValue={row?.SainId}
            >
              <Table
                data={[value]}
                columns={[
                  {
                    name: "Break Pack TI",
                    accessor: (rowData: any) => ({
                      value: rowData?.DimensionData?.OuterDimensions?.Ti,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack HI ",
                    accessor: (rowData: any) => ({
                      value: rowData?.DimensionData?.OuterDimensions?.Hi,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack Qty",
                    accessor: (rowData: any) => {
                      return {
                        value:
                          rowData?.DimensionData?.OuterDimensions?.BreakPackQty,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack Length",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.OuterDimensions?.Length
                          ? `${rowData?.DimensionData?.OuterDimensions?.Length} ${rowData?.DimensionData?.OuterDimensions?.LengthUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack Width",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.OuterDimensions?.Width
                          ? `${rowData?.DimensionData?.OuterDimensions?.Width} ${rowData?.DimensionData?.OuterDimensions?.WidthUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack Height",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.OuterDimensions?.Height
                          ? `${rowData?.DimensionData?.OuterDimensions?.Height} ${rowData?.DimensionData?.OuterDimensions?.HeightUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Break Pack Weight",
                    accessor: (rowData: any) => {
                      return {
                        value: rowData?.DimensionData?.OuterDimensions?.Weight
                          ? `${rowData?.DimensionData?.OuterDimensions?.Weight} ${rowData?.DimensionData?.OuterDimensions?.WeightUOM}`
                          : null,
                      };
                    },
                    render: DefaultTableCellRender,
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : (
          "--"
        );
      },
    },
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.searchProductData(),
      orderBy: "OrderBy=createdDate asc",
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default ProductMeasurements;
